import React, { useState, lazy, Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Component/Header/Header"; // Left sidebar
import Sidebar from "./Component/Header/Sideabar/Sidebar"; // Top navbar

// Code-split: loads as its own chunk after the page is interactive, and renders
// nothing at all when the ai_assistant module is switched off.
const ChatWidget = lazy(() => import("./Component/Assistant/ChatWidget"));

// Same treatment for staff chat: its own chunk, and it renders nothing at all
// when the internal_chat module is switched off.
const ChatDock = lazy(() => import("./Component/Chat/ChatDock"));

const KIOSK_ROUTES = ["/Admin/Kiosk"];

export default function Admin() {
  // Desktop (>1024px) starts open, matching current behavior.
  // Phones/tablets (<=1024px) start closed — sidebar becomes a hamburger-triggered overlay drawer.
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => window.innerWidth > 1024);
  const location = useLocation();

  const isKiosk = KIOSK_ROUTES.some((r) => location.pathname.startsWith(r));

  const handleToggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  if (isKiosk) {
    return <Outlet />;
  }

  return (
    <div style={{ display: "flex" }}>
      {/* Left sidebar */}
      <Header isOpen={isSidebarOpen} />
      {/* Backdrop — only visible/interactive on mobile/tablet via CSS, closes the drawer on tap */}
      {isSidebarOpen && (
        <div className="sidebar-backdrop" onClick={handleToggleSidebar} />
      )}
      <div className="main-content">
        <Sidebar isOpen={isSidebarOpen} onToggle={handleToggleSidebar} />

        <div>
          <Outlet />
        </div>
      </div>

      <Suspense fallback={null}>
        <ChatWidget />
      </Suspense>

      <Suspense fallback={null}>
        <ChatDock />
      </Suspense>
    </div>
  );
}
